import { useRef, useState } from "react";
import { FileDropzoneProps } from "./filedropzoneType";
import { useNotification } from "../notification";

export function useFileDropzone({ onFileLoaded, onFileRemoved, setResult }: FileDropzoneProps) {
    const inputRef = useRef<HTMLInputElement>(null);
    const [file, setFile] = useState<File | null>(null);
    const [isRemoving, setIsRemoving] = useState<boolean>(false)
    // const [isDragging, setIsDragging] = useState(false);
    const { showNotification } = useNotification()


    function isValidFile(file: File) {
        if (!file.type.includes("spreadsheet") && !file.type.includes("text")) {
            return true
        }
        return false
    }

    function handleFiles(files: FileList | null) {
        if (!files || files.length === 0) return;
        const f = files[0];

        if (isValidFile(f)) {
            showNotification({
                type: "warning",
                title: "Arquivo inválido",
                message: "Selecione um arquivo válido (.xlsx ou .csv).",
            });
            setFile(null);
            return;
        }

        setFile(f);
        onFileLoaded && onFileLoaded(f);
    }

    function removeFile() {
        setIsRemoving(true);

        setTimeout(() => {
            setFile(null);
            setIsRemoving(false);
            setResult(null)
            inputRef.current && (inputRef.current.value = "");
            onFileRemoved && onFileRemoved();
        }, 200);
    }

    return{
        file,
        isRemoving,
        handleFiles,
        removeFile,
        inputRef
    }
}